// src/lib/authToken.js
//
// Ponte entre o hook useAuth0 (React) e o apiService (módulo puro, fora de componentes).
// useAuth.js registra aqui a função getAccessTokenSilently a cada render; apiService.js
// a consome para anexar o header Authorization em toda chamada à API.

let tokenGetter = null;

export function registerTokenGetter(fn) {
  tokenGetter = fn;
}

export async function getAccessToken() {
  if (!tokenGetter) {
    console.warn('[authToken] getAccessToken chamado antes do useAuth0 registrar o tokenGetter.');
    return null;
  }
  try {
    return await tokenGetter();
  } catch (err) {
    console.warn('[authToken] Falha ao obter access token:', err);
    return null;
  }
}

// Helper para chamadas fetch() cruas fora do apiService/fetchWithRetry:
// const res = await fetch(url, { headers: { ...await authHeaders() } });
export async function authHeaders() {
  const token = await getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
